export default __webpack_public_path__ + "static/media/logo-color.bafd0dd6.png";